import Charts from './PieChartComponent';
import Infos from './InfosComponent';
import Table from './TableComponent';

const StorageCostChart = Charts.StorageCostChartComponent;
const BandwidthCostChart = Charts.BandwidthCostChartComponent;
const RequestsCostChart = Charts.RequestsCostChartComponent;

export default {
  StorageCostChart,
  BandwidthCostChart,
  RequestsCostChart,
  Table,
  Infos
};



// WEBPACK FOOTER //
// ./src/components/aws/s3Analytics/index.js